module.exports = __webpack_public_path__ + "static/media/favicon.bd5f4775.png";